<template>
    <Loader v-if="loading"/>
    <div v-if="loaded_data">
        
        <Card>
            <template #header>
                <div class="p-3 pb-0">
                    <h4>{{ utente.cognome }} {{ utente.nome }}</h4>
                </div>
            </template>
            <template #content>
                     <Button label="Reset password" raised class="p-button p-button-danger" @click="openDialog" style="margin-bottom:5px"/>
                <Accordion :activeIndex="0"  @tab-open="getCorsiPersonale($event)">
                    <AccordionTab header="Dettagli">
                        <div class="flex align-items-start flex-wrap">
                            <div class="col-12 flex flex-wrap">
                                <div class="col-12 md:col-6 flex flex-column gap-2">
                                    <label for="codfis">Nome</label>
                                    <InputText id="codfis" v-model="utente.nome" :disabled="!update" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.nome}]"/>
                                </div>
                                <div class="col-12 md:col-6 flex flex-column gap-2">
                                    <label for="codfis">Cognome</label>
                                    <InputText id="codfis" v-model="utente.cognome" :disabled="!update" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.cognome}]"/>
                                </div>
                                <div class="col-12 md:col-6 flex flex-column gap-2">
                                    <label for="codfis">Codice fiscale</label>
                                    <InputText id="codfis" v-model="utente.codfis" :disabled="!update" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.codfis}]"/>
                                </div>
                                <div class="col-12 md:col-6 flex flex-column gap-2">
                                    <label for="codfis">Email</label>
                                    <InputText id="codfis" v-model="utente.username" :disabled="!update" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.email}]"/>
                                </div>
                                <div class="col-12 md:col-6 flex flex-column gap-2">
                                    <label for="type_visita">Tipologia Visita</label>
                                    <Dropdown id="type_visita" v-model="utente.id_type_visita_ext" :options="types_visita" optionLabel="nome" optionValue="id" placeholder="Seleziona tipologia visita" :disabled="!update" showClear class="w-full"/>
                                </div>
                                <div class="p-field col-12 md:col-6 flex flex-column">
                                    <label class="col-12">Tipologia</label><br>
                                     <div class="flex justify-content-between">
                                        <div v-for="type in types_personale" :key="type.id"  class="col-6 flex align-items-center">
                                            <Checkbox v-model="utente[type.prop]" :binary="true" :disabled="!update"/>
                                            <label class="ml-2 mr-2">{{ type.nome }}</label>
                                        </div>
                                     </div>
                                </div>
                                <div class="p-field col-12 md:col-6 flex flex-column">
                                    <label class="col-12 font-bold">Permessi App</label>
                                    <div class="flex flex-wrap gap-3 p-3">
                                        <div class="flex align-items-center">
                                            <Checkbox v-model="utente.is_admin" :binary="true" :disabled="!update"/>
                                            <label class="ml-2 mr-4">Admin</label>
                                        </div>
                                        <div class="flex align-items-center">
                                            <Checkbox v-model="utente.is_news" :binary="true" :disabled="!update"/>
                                            <label class="ml-2 mr-4">News</label>
                                        </div>
                                        <div class="flex align-items-center">
                                            <Checkbox v-model="utente.is_magazzino" :binary="true" :disabled="!update"/>
                                            <label class="ml-2 mr-4">Magazzino</label>
                                        </div>
                                    </div>
                                </div>

                                <!-- Stato Attivo -->
                                <div class="p-field col-12 md:col-6 flex flex-column">
                                    <label class="col-12 font-bold">Stato</label>
                                    <div class="flex align-items-center gap-3 p-3">
                                        <RadioButton v-model="utente.attivo" :value="1" inputId="det_attivo_si" :disabled="!update" />
                                        <label for="det_attivo_si" class="mr-4">Attivo</label>
                                        <RadioButton v-model="utente.attivo" :value="0" inputId="det_attivo_no" :disabled="!update" />
                                        <label for="det_attivo_no" :style="utente.attivo==0 ? 'color:red;font-weight:bold' : ''">Non attivo</label>
                                    </div>
                                </div>

                                <div class="p-field col-12 md:col-6 flex flex-column">
                                    <label class="col-12 font-bold">Immagine Profilo App</label>
                                    <div class="col-12 flex flex-column gap-2">
                                        <div v-if="utente.img" class="mb-2">
                                            <img :src="getImgUrl(utente.img)" alt="Immagine attuale" style="max-height: 100px; object-fit: contain; border-radius: 4px;" />
                                        </div>
                                        <input type="file" accept="image/*" @change="onImageChange" :disabled="!update" class="p-inputtext p-component" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 flex justify-content-end align-items-center">
                            <label class="mr-2">{{!update ? 'Modifica' : 'Salva'}} dati</label>
                            <InputSwitch v-model="update" @change="changeUpdate"/>
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Corsi">
                        <DataTable :value="corsi" tableStyle="min-width: 50rem" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" >
                            <Column field="nome" header="Nome">
                                <template #body="{data}">
                                    <Button :label="data.nome" class="p-button-link" @click="navigateTo('corso',data.id)"/>
                                </template>
                            </Column>
                            <Column field="tipo_corso" header="Tipologia"></Column>

                            <Column field="data_inizio" header="Data inizio">
                                <template #body="{data}">
                                    {{ moment(data.data_inizio).format('DD/MM/Y') }}
                                </template>
                            </Column>
                            <Column field="data_fine" header="Data fine">
                                <template #body="{data}">
                                    {{ moment(data.data_fine).format('DD/MM/Y') }}
                                </template>
                            </Column>
                        </DataTable>
                    </AccordionTab>

                    <AccordionTab header="Presenze" v-if="utente.is_allenatore">
                        <DataTable :value="presenze" tableStyle="min-width: 50rem" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" >
                            <Column field="mese" header="Mese">
                                <template #body="{data}">
                                    {{ formatMese(data.mese) }}
                                </template>
                            </Column>
                            <Column field="quanti" header="#Corsi"></Column>
                            <Column field="previste" header="Previste"></Column>
                            <Column field="assenze" header="Assenze"></Column>
                            <Column field="sostituzioni" header="Sostituzioni"></Column>
                            <Column header="Totale">
                                <template #body="{data}">
                                    {{ data.previste - data.assenze + data.sostituzioni }}
                                </template>
                            </Column>
                            <Column header="Dettaglio">
                                <template #body="{data}">
                                    <Button
                                        icon="pi pi-list"
                                        class="p-button-sm p-button-outlined"
                                        :loading="loadingCorsi && selectedMese === data.mese"
                                        @click="togglePresenzePerCorso(data.mese)"
                                        :label="selectedMese === data.mese ? 'Chiudi' : 'Per corso'"
                                    />
                                </template>
                            </Column>
                        </DataTable>

                        <!-- Box presenze per corso -->
                        <div v-if="selectedMese" class="mt-3 p-3 border-round surface-50" style="border: 1px solid var(--surface-border)">
                            <div class="flex align-items-center mb-3">
                                <i class="pi pi-chart-bar mr-2 text-primary"></i>
                                <span class="font-semibold text-lg">Presenze per corso – {{ formatMese(selectedMese) }}</span>
                            </div>
                            <div v-if="loadingCorsi" class="text-center p-3">
                                <i class="pi pi-spin pi-spinner" style="font-size:1.5rem"></i>
                            </div>
                            <DataTable v-else :value="presenzePerCorso" tableStyle="min-width: 40rem" class="p-datatable-sm">
                                <Column field="nome_corso" header="Corso"></Column>
                                <Column field="previste" header="Previste"></Column>
                                <Column field="assenze" header="Assenze">
                                    <template #body="{data}">
                                        <span :class="data.assenze > 0 ? 'text-red-500 font-semibold' : ''">{{ data.assenze }}</span>
                                    </template>
                                </Column>
                                <Column field="sostituzioni" header="Sost.">
                                    <template #body="{data}">
                                        <span :class="data.sostituzioni > 0 ? 'text-green-500 font-semibold' : ''">{{ data.sostituzioni }}</span>
                                    </template>
                                </Column>
                                <Column header="Totale">
                                    <template #body="{data}">
                                        <strong>{{ data.totale }}</strong>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </AccordionTab>

                    <AccordionTab header="Rimborsi" v-if="utente.is_allenatore" @tab-open="getReimbursements">
                        <DataTable :value="reimbursements" tableStyle="min-width: 50rem" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" >
                            <Column field="torneo_nome" header="Torneo" sortable></Column>
                            <Column field="data_inizio" header="Data" sortable>
                                <template #body="{data}">
                                    {{ moment(data.data_inizio).format('DD/MM/YYYY') }}
                                </template>
                            </Column>
                            <Column field="amount" header="Importo" sortable>
                                <template #body="{data}">
                                    € {{ parseFloat(data.amount).toFixed(2) }}
                                </template>
                            </Column>
                        </DataTable>
                        
                        <div class="mt-3 text-right">
                            <strong>Totale Rimborsi: € {{ totalReimbursements.toFixed(2) }}</strong>
                        </div>
                    </AccordionTab>
                </Accordion>
            </template>
        </Card>
    </div>


    <Dialog header="Reset Password" v-model:visible="showDialog" modal>
        <form @submit.prevent="handleSubmit">
        <div class="field">
          <label for="file">Confermi di voler inviare una nuova password al personale?</label><br/>
        
        </div>
        
        <div class="dialog-footer">
          <Button label="Invia" icon="pi pi-check" type="submit" />
        </div>
      </form>
    </Dialog>
</template>

<script>
import {ref, onMounted, getCurrentInstance, onUpdated, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import Loader from "@/components/Loader.vue"
import Service from '@/services/levante-api/levante-api'
import moment from 'moment'
import { useToast } from 'primevue/usetoast';

export default {
    components: {
        Loader 
    },
    
    setup () { 
        const toast = useToast();
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus)
        const loading = ref(false)
        const loaded_data = ref(false)
        const update = ref(false);
        const submitted = ref(false)
        const validationErrors = ref({})
        const route = useRoute()
        const id = route.params.id
        const utente = ref()
        const types_personale = ref([]) 
        const types_visita = ref([])
        const corsi = ref([]) 
        const selectedImage = ref(null);
        const showDialog = ref(false);
        const presenze = ref([])
        const reimbursements = ref([])
        const presenzePerCorso = ref([])
        const selectedMese = ref(null)
        const loadingCorsi = ref(false)
        const lifeTime = 3000;

        
        const getDetails = async () => {
            await service.getDetails('staff', id)
            .then((res) => {
                utente.value = res.items[0]
                utente.value.is_responsabile = Boolean(utente.value.is_responsabile)
                utente.value.is_allenatore = Boolean(utente.value.is_allenatore)
                utente.value.is_admin = Boolean(utente.value.is_admin)
                utente.value.is_news = Boolean(utente.value.is_news)
                utente.value.is_magazzino = Boolean(utente.value.is_magazzino)
                utente.value.attivo = parseInt(utente.value.attivo ?? 1)
                loaded_data.value = true
                console.log(utente.value.is_allenatore);
                getPresenze()
            })
        }

        const getTipoPersonale = async () => {
            await service.getTypePersonale()
            .then((res) => {
                types_personale.value = res.items
                types_personale.value.forEach(type => {
                    type.prop = `is_${type.nome.toLowerCase()}`
                })
                //loaded_data.value = true
            })
        }

        const getTypeVisita = async () => {
            await service.getTypeVisita()
            .then((res) => {
                types_visita.value = res.items || res.data || res
            })
        }

        const getCorsiPersonale = async (event) => {
            if (event.index == 1) {            
                await service.getCorsiPersonale(id)
                .then((res) => {
                    corsi.value = res.items
                   // loaded_data.value = true
                })
            }
        }     
        const getPresenze = async (event) => {
            await service.getPresenzeStaff(id)
            .then((res) => {
                presenze.value = res.items
                getReimbursements()
            })
        }

        const togglePresenzePerCorso = async (mese) => {
            if (selectedMese.value === mese) {
                selectedMese.value = null
                presenzePerCorso.value = []
                return
            }
            selectedMese.value = mese
            loadingCorsi.value = true
            await service.getPresenzeStaffPerCorso(id, mese)
            .then((res) => {
                presenzePerCorso.value = res.items
            })
            .finally(() => {
                loadingCorsi.value = false
            })
        }

        const formatMese = (mese) => {
            if (!mese) return ''
            const [anno, m] = mese.split('-')
            const nomiMesi = ['','Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre']
            return `${nomiMesi[parseInt(m)] || m} ${anno}`
        }

        const getReimbursements = async (event) => {
            console.log("getReimbursements");
           // if (event.index == 3) {            
                await service.getStaffReimbursements(id)
                .then((res) => {
                    if (res.items && res.items.status) {
                        reimbursements.value = res.items.data || []
                    }
                })
           // }
        }

        const totalReimbursements = computed(() => {
            return reimbursements.value.reduce((sum, r) => sum + parseFloat(r.amount), 0)
        })

        const navigateTo = (nome_rotta, id) => {
            window.open(`/${nome_rotta}/${id}/dettagli`, '_blank')
        }
     const validateForm = () => {
      // Validazione Utente
      let validate_properties = [
      'nome',
      'cognome',
      
      ]
      
      validate_properties.forEach( prop => {
        if (utente.value[prop] == '' || utente.value[prop] == null) {
          validationErrors.value[prop] = true
        } else {
          delete validationErrors.value[prop];
        }
      })
      // Fine Validazione Utente
      
      // Validazione selezione corsi
      /*if(corsi.value.some(corso => corso.value)){
        delete validationErrors.value.some_corsi
      }else{
        validationErrors.value.some_corsi = true
      }*/
      // Fine Validazione selezione corsi
      
      console.log(validationErrors.value);
      return !Object.keys(validationErrors.value).length;
    }
            const handleSubmit = async () => {
            
            const formData = new FormData();
            formData.append('id', id);

            try {
                await service.sendResetTrainer(formData)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    showDialog.value = false
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }
                    
                });
                
            } catch (error) {
                alert('Errore nella richiesta.');
            }
            showDialog.value = false
            
        };
    
    const sendDataNewPersonale = async () => {
      submitted.value = true;
      validationErrors.value = []
      if(validateForm()){
        loading.value = true
        let fd = new FormData();        
        utente.value.type_corso = corsi.value.filter(corso => corso.value)
        utente.value.email = utente.value.username
        fd.append('utente', JSON.stringify(utente.value));
        
        if (selectedImage.value) {
            fd.append('img', selectedImage.value);
        }

        service.sendDataNewPersonale(fd)
        .then((res) => {
          let severity = res.item.esito
          let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
          let detail = res.item.messaggio
          if(res.item.esito == 'success'){
            getDetails()
          }

          toast.add({severity:severity, summary: summary, detail:detail});
        }).finally(() => {
          loading.value = false
        })
      }else{
        toast.add({severity:'warn', summary: 'Attenzione', detail:`Ci sono dei dati mancanti`});
      }
    }
        const changeUpdate = () => {
            if (!update.value) {
                sendDataNewPersonale()
            }
        }

        const onImageChange = (e) => {
            if (e.target.files && e.target.files[0]) {
                selectedImage.value = e.target.files[0];
            }
        };

        const getImgUrl = (path) => {
            if (!path) return '';
            if (path.startsWith('http')) return path;
            return `${process.env.VUE_APP_LEVANTE_API_URL}/../storage/app/public/${path}`;
        };

        const openDialog = ()=>{
            showDialog.value=true;
        }
        onMounted(() => { 
            loading.value = true
            const promises = [getDetails(), getTipoPersonale(), getTypeVisita()]
            
            Promise.all(promises)
            .then(()=>{
                
            }).finally(()=>{
                loaded_data.value = true
                loading.value = false
            })
        })
        
        return {
            moment,
            loading,
            loaded_data,
            utente,
            update,
            submitted,
            validationErrors,
            types_personale,
            types_visita,
            corsi,
            presenze,
            getCorsiPersonale,
            changeUpdate,showDialog,openDialog,
            onImageChange,
            getImgUrl,
            navigateTo,
            handleSubmit,
            reimbursements,
            getReimbursements,
            totalReimbursements,
            presenzePerCorso,
            selectedMese,
            loadingCorsi,
            togglePresenzePerCorso,
            formatMese
        }
    },
}
</script>

<style>
</style>
